import type { OutcomeChip } from './callApi';

/**
 * Чипы бизнес-итога (ТЗ §2.13, §1.22).
 *
 * ТЗ прямо разрешает ставить итог в двух моментах — во время разговора и в
 * «Обработке» после него, — поэтому чипы вынесены из окна разговора отдельным
 * компонентом и живут в обоих экранах одной конструкцией.
 *
 * Итог необязателен: факт разговора фиксирует автоматика. Поэтому здесь нет
 * ни «звёздочки обязательного поля», ни запрета уйти без выбора.
 */
export function OutcomeChips({
  outcomes,
  pickedOutcomeId,
  onPick,
}: {
  outcomes: OutcomeChip[];
  pickedOutcomeId: number | null;
  onPick: (outcome: OutcomeChip) => void;
}) {
  return (
    <div data-tel="outcome-chips" className="mt-4">
      <div
        className="text-ops-micro font-bold uppercase tracking-[0.08em]"
        style={{ color: 'var(--ops-text-tertiary)' }}
      >
        Итог разговора
      </div>

      {outcomes.length === 0 ? (
        <p className="mt-2 text-ops-caption" style={{ color: 'var(--ops-text-secondary)' }}>
          Справочник итогов пуст — заполняется в разделе «Справочники».
        </p>
      ) : null}

      <div className="mt-2 flex flex-wrap gap-2">
        {outcomes.map((outcome) => (
          <button
            key={outcome.id}
            type="button"
            onClick={() => onPick(outcome)}
            className={[
              'rounded-ops-pill px-3 py-1.5 text-ops-label',
              pickedOutcomeId === outcome.id ? 'font-semibold' : '',
            ].join(' ')}
            style={
              pickedOutcomeId === outcome.id
                ? { background: chipColor(outcome.color), color: '#fff' }
                : {
                    background: 'var(--ops-surface-2)',
                    color: 'var(--ops-text)',
                    border: '1px solid var(--ops-border)',
                  }
            }
          >
            {outcome.name}
          </button>
        ))}
      </div>
    </div>
  );
}

function chipColor(color: OutcomeChip['color']): string {
  switch (color) {
    case 'ok':
      return 'var(--ops-success)';
    case 'warn':
      return 'var(--ops-warning)';
    case 'danger':
      return 'var(--ops-danger)';
    default:
      return 'var(--ops-primary)';
  }
}
